module.exports = __webpack_public_path__ + "img/pres-09.96d43740.png";